export default __webpack_public_path__ + "static/ValentynShapoval-e761c43dbfa7b1697c5619ba16e2f7f8.png";